<template>
<!-- this page should be deleted after Refer and Earn Giveaway is over -->
    <div class="container my-3">
        <div class="row">
            <div class="offset-md-3 col-md-6 offset-sm-2 col-sm-8 offset-0 col-12">
                <form>
                    <h3 class="my-3">Become a Referrer</h3>
                    <!-- Desktop View Alerts -->
                    <div v-if="msg !== ''" :class="`alert alert-${color} text-center mb-3 mt-3 p-1 d-none d-md-block`" role="alert">
                        <i class="fas fa-exclamation-circle"></i> {{ msg }}
                    </div>
                    <p><i class="fas fa-user"></i> {{user.name | capitalize}}</p>
                    <p><i class="fas fa-at"></i> {{user.userHandle}}</p>
                    <p><i class="fas fa-university"></i> Your earnings deposit details</p>
                    <div class="mt-1">
                        <span class="text-dark-green">Bank Name</span>
                        <input v-model="bankName" @focus="agreement = false" type="text" required class="form-control no-lines" placeholder="Ex. Somewhere Bank">
                    </div>
                    <div class="mt-3">
                        <span class="text-dark-green">Account Number</span>
                        <input v-model="acctNumber" @focus="agreement = false" type="number" required class="form-control no-lines" placeholder="Ex. 0123456789">
                    </div>
                    <div class="mt-3">
                        <span class="text-dark-green">Account Name</span>
                        <input v-model="acctName" @focus="agreement = false" type="text" required class="form-control no-lines" placeholder="Ex. John Doe">
                    </div>
                    <div class="mt-3">
                        <div @click.prevent="requiredFieldsCheck" class="form-check">
                            <label class="form-check-label" for="agreement">
                                <input v-model="agreement" class="form-check-input" type="checkbox" value="" id="agreement">
                                I agree my deposit details are correct.
                            </label>
                        </div>
                    </div>
                    <!-- Mobile View Alerts -->
                    <div v-if="msg !== ''" :class="`alert alert-${color} text-center mb-3 mt-3 p-1 d-md-none`" role="alert">
                        <i class="fas fa-exclamation-circle"></i> {{ msg }}
                    </div>
                    <!-- Import Add Marketer Btn -->
                    <div class="text-center mt-3">
                        <app-add-marketer-btn 
                            :buttonText="'Submit'" 
                            :buttonDisabled="!agreement" 
                            :userId="user._id" 
                            :bankObj="bankObj" 
                            @emitColor="assignColor" 
                            @emitMsg="assignMsg">
                        </app-add-marketer-btn>
                    </div>
                    <div class="mt-3">
                        <p class="text-center">
                            <router-link :to="{ name: 'profile' }">Back to Profile</router-link> 
                        </p>
                    </div>
                </form>
                <p class="text-danger font-italic text-center">
                    <small>
                        Note: registeration is only open for a limited time, 
                        remind your friends and friend's friend to come register as a 
                        Referrer to participate!
                    </small>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import AddMarketerBtn from '../portalParts/AddMarketerBtn.vue'
import LayoutUser from '@/layouts/User.vue'

export default {
    name: "CreateReferrer",
    data() {
        return {
            bankName: '',
            acctNumber: '',
            acctName: '',
            msg: '',
            color: 'danger',
            bankObj: null,
            agreement: false,
        }
    },
    methods: {
        ...mapActions(['']),
        assignColor(val) {
            this.color = val
        },
        assignMsg(val) {
            this.msg = val
        },
        requiredFieldsCheck() {
            if(this.bankName === ''){ this.msg = "Your bank name is required!"; return }
            if(this.acctNumber === ''){ this.msg = "Your account number is required!"; return }
            if(this.acctName === ''){ this.msg = "Your account name is required!"; return }
            this.bankObj = {
                bankName: this.bankName,
                acctNumber: this.acctNumber,
                acctName: this.acctName
            }
            this.agreement = !this.agreement
        }
    },
    computed: {
        ...mapGetters(['user']),
    },
    components: {
        appAddMarketerBtn: AddMarketerBtn
    },
    created() {
        this.$emit('update:layout', LayoutUser);
    }
}
</script>